import { z } from 'zod';

import { CompanyId, LoanImportId, UserId } from '../../BrandedIds';
import { ImportSource, ImportStatus, ImportType } from '../../loan/LoanImport';
import { zodTemporalInstant } from '../../Temporal';

export const ExportableLoanImport = z
  .object({
    id: LoanImportId,
    companyId: CompanyId,
    userId: UserId.optional(),
    fileName: z.string().optional(),
    totalRows: z.number(),
    status: ImportStatus,
    type: ImportType,
    source: ImportSource,
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'LoanImport' });

export type ExportableLoanImport = z.infer<typeof ExportableLoanImport>;
